import React from "react";
import { Link } from "react-router-dom";

const FooterOne = () => {
  return (
    <footer>
      <div className="footer-area">
        {/* <div className="location-block">
          <a href="https://g.co/kgs/hfchxH9" target="_blank">
            <img src="/img/custom-imgs/pin.png" alt="" className="locationImg" />
          </a>
        </div> */}
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <div className="logo">
                    <Link to="/">
                      <img
                        src="/img/logo-1.webp"
                        alt="footer-img"
                        className="logo-footer"
                      />
                    </Link>
                  </div>
                  {/* <div className="footer-social">
                    <ul className="list-wrap">
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="active">
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-google-plus-g"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div> */}
                  {/* <div className="footer-contact">
                    <span>For Support</span>
                    <span className="title">
                      <a href="tel:+61485972839">+61485972839</a>
                      <> / </>
                      <a href="tel:+61480008440">+61480008440</a>
                    </span>
                    <div className="" style={{display: "flex", gap: ".7rem", marginTop: "1rem"}}>
                      <div className="">
                        <a href="https://www.facebook.com/thedigitalcreativedesignsau1/" className="">
                            <img
                              src="/img/facebook.svg"
                              alt="footer-img"
                              style={{ width: "1.8rem" }}
                            />
                        </a>
                      </div>
                      <div className="">
                      <a href="https://www.instagram.com/thedigitalcreativedesignsau/" className="" >
                            <img
                              src="/img/instagram.svg"
                              alt="footer-img"
                              style={{ width: "1.8rem" }}
                            />
                        </a>
                      </div>
                      <div className="">
                      <a href="https://au.pinterest.com/thedigitalcreativedesignsau" className="">
                            <img
                              src="/img/pinterest.svg"
                              alt="footer-img"
                              style={{ width: "1.8rem" }}
                            />
                        </a>
                      </div>
                      <div className="">
                      <a href="https://www.linkedin.com/company/thedigitalcreativedesignsau/" className="">
                            <img
                              src="/img/linkedin.png"
                              alt="footer-img"
                              style={{ width: "1.8rem" }}
                            />
                        </a>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Navigation</h4>
                  <div className="fw-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li>
                        <Link to="/portfolio">Portfolio</Link>
                      </li>
                      <li>
                        <Link to="/services">Service</Link>
                      </li>
                      {/* <li>
                        <Link to="/pricing">Pricing</Link>
                      </li> */}
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Terms and Conditions</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Pages</h4>
                  <div className="fw-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/about-us">About</Link>
                      </li>
                      <li>
                        <Link to="/contact">Pricing</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                      <li>
                        <Link to="/contact">Request for Demo</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Contact Us</h4>
                  <div className="footer-about">
                    <ul className="list-wrap">
                      <li>
                        <img src="/img/icon/phone_icon.svg" alt="footer-img" />
                        <span><a href="tel:14062251473">14062251473</a></span>
                      </li>
                      <li>
                        <img src="/img/icon/mail_icon.svg" alt="footer-img" />
                        <a href="mailto:info@thedigitalcreativedesigns.com">
                          info@thedigitalcreativedesigns.com
                        </a>
                      </li>
                      <li>
                        <img src="/img/icon/loction_icon.svg" alt="footer-img" />
                        <span>1001 S. Main St. STE 500 Kalispell, MT 59901</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="copyright-text text-center">
                  <p>
                    © {new Date().getFullYear()} The Digital Creative Designs. All Rights
                    Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
